// ExportToolbar.js — Reusable export toolbar with Excel + PDF buttons
import React from 'react';
import { FileSpreadsheet, Printer } from 'lucide-react';

const ExportToolbar = ({ onExportExcel, onExportPdf }) => {
  return (
    <div className="flex items-center gap-2" data-no-print>
      <button
        onClick={onExportExcel}
        className="flex items-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-[0.12em] border border-zinc-300 bg-white text-zinc-600 hover:border-[#4D4D4D] hover:text-black transition-all"
      >
        <FileSpreadsheet className="w-3.5 h-3.5" />
        Excel
      </button>
      <button
        onClick={onExportPdf}
        className="flex items-center gap-2 px-3 py-2 text-xs font-mono uppercase tracking-[0.12em] border border-zinc-300 bg-white text-zinc-600 hover:border-[#4D4D4D] hover:text-black transition-all"
      >
        <Printer className="w-3.5 h-3.5" />
        PDF
      </button>
    </div>
  );
};

export default ExportToolbar;
